import React from "react";
import { Plane, Calendar, Clock, Users, ArrowRight, Star } from "lucide-react";
import { PartnerBadges, VerifiedBadgeIcon } from "@/components/PartnerBadges";

export function JetHeader({ listing }) {
  return (
    <div className="glass p-8">
      <div className="flex items-start justify-between mb-4">
        <div className="w-16 h-16 bg-[#D4AF37] flex items-center justify-center">
          <Plane className="w-8 h-8 text-black" />
        </div>
        <div className="flex items-center gap-2">
          <Star className="w-5 h-5 text-[#D4AF37] fill-current" />
          <span className="text-[#D4AF37] font-medium">Premium Flight</span>
        </div>
      </div>
      
      <div className="flex items-center gap-4 text-3xl font-black mb-2">
        <span>{listing.origin_city}</span>
        <ArrowRight className="w-8 h-8 text-white/40" />
        <span>{listing.destination_city}</span>
      </div>
      
      <p className="text-xl text-white/60 mb-2">{listing.jet_model}</p>
      <div className="flex items-center gap-2 text-white/60 mb-3">
        <span>Operated by <strong className="text-white">{listing.partner_name}</strong></span>
        {listing.partner_verified && <VerifiedBadgeIcon className="w-5 h-5" />}
      </div>
      
      {listing.partner_badges?.length > 0 && (
        <PartnerBadges badges={listing.partner_badges} size="sm" maxShow={4} />
      )}
    </div>
  );
}

export function JetDetailsGrid({ listing }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
      <DetailCard icon={Calendar} label="Date" value={listing.departure_date} />
      <DetailCard icon={Clock} label="Departure" value={listing.departure_time} />
      <DetailCard icon={Users} label="Available" value={`${listing.available_seats} seats`} />
      <DetailCard icon={Plane} label="Aircraft" value={listing.jet_model} />
    </div>
  );
}

function DetailCard({ icon: Icon, label, value }) {
  return (
    <div className="glass p-5">
      <div className="flex items-center gap-2 text-white/40 text-sm mb-1">
        <Icon className="w-4 h-4" />
        <span>{label}</span>
      </div>
      <p className="font-bold text-lg">{value}</p>
    </div>
  );
}
